export default __webpack_public_path__ + "static/media/example3.64274b51.png";